import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/_alert';
import { DatastoreService } from 'src/app/services/datastore.service';
import { AvailabilityService } from 'src/app/services/jrni/availability.service';
import { DepartmentService } from 'src/app/services/jrni/department.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/services/jrni/login.service';
import { MemberService } from 'src/app/services/jrni/member.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from 'src/app/services/jrni/api.service';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss']
})
export class AccessComponent implements OnInit {
  selectedDepartment: any;
  pageTitle: any;
  locationPageText: any;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  showLogin = true;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  submitted: boolean = false;
  access_page_sub_title: any;
  hide: boolean = true;

  passwordResetForm: FormGroup;
  shouldShowPasswordReset: boolean = false;
  resetSubmitted: boolean = false;
  resetSuccess: boolean = false;
  resetPath: string = '';
  resetError: boolean = true;
  loginError: boolean = false;
  loginErrorMessage: string = '';

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private datastoreService: DatastoreService,
    private memberService: MemberService,
    private apiService: ApiService,
    private loginService: LoginService
  ) { }

  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
    password: new FormControl('', Validators.required)
  });

  resetPasswordForm: FormGroup = new FormGroup({
    resetemail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
  });

  // Getter for easy access to form fields
  get form() { return this.loginForm.controls; }
  get resetForm() { return this.passwordResetForm.controls; }

  togglePasswordVisible() {
    this.hide = !this.hide;
  }

  routerGoBack() {
    this.router.navigate(['/departments']);
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  ngOnInit() {
    this.resetPath = '/?client=kent&environment=kenthwrc#/update-password';
    this.scrollToTop();
    this.spinner.show();
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    // this.departmentService.get().then(selectedDepartment => {
    //   if (selectedDepartment === undefined) {
    //     this.restartJourney();
    //   } else {
    //     this.selectedDepartment = selectedDepartment;

    this.memberService.getMember().then(async member => {
      if (member) {
        this.router.navigate(['/departments']);
        this.spinner.hide();
      } else {
        sessionStorage.removeItem("auth_token");
        sessionStorage.removeItem("login");
        // remove the value from localStorage
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_token");
      }
      this.datastoreService.parentDepartment = await this.departmentService.getParentDepartment();
      this.departmentService.set(this.datastoreService.parentDepartment);
      this.selectedDepartment = this.datastoreService.parentDepartment;

      // Get the configurable data
      if (this.datastoreService.parentDepartment.hasOwnProperty('extra')) {
        // Set the title on the login page to the title from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('access_page_title') ? this.pageTitle = this.datastoreService.parentDepartment.extra.access_page_title : this.pageTitle = "Location title not set";
        // Set the extra text on the page to the text taken from the business question
        this.datastoreService.parentDepartment.extra.hasOwnProperty('access_page_sub_title') ? this.access_page_sub_title = this.datastoreService.parentDepartment.extra.access_page_sub_title : null;
      }
      this.spinner.hide();
    })
    //   }
    // }, err => {
    //   console.log(err);
    //   this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
    //   this.spinner.hide();
    // });
  }


  showLoginToggle() {
    this.showLogin = true
  }

  register() {
    this.router.navigate(['/register']);
  }

  continueAsGuest() {
    sessionStorage.removeItem("auth_token");
    sessionStorage.removeItem("login");
    // remove the value from localStorage
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_token");
    this.continue()
  }

  continue() {


    this.router.navigate(['/departments']);
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scroll(0, 0);
  }


  onSubmit() {
    this.submitted = true;
    // stop here if the login form is invalid
    if (this.loginForm.invalid) {
      return;
    } else {
      this.loginService.loginMember(this.selectedDepartment, this.loginForm.value).then(async res => {
        await this.memberService.setMember(res);
        this.continue()
      })
        .catch((error: HttpErrorResponse) => {
          console.log(error)
          if (error || error['response'] && error['response'].status === 401) {
            this.scrollToTop()
            this.alertService.error(this.translateService.instant('LOGIN.EMAIL_NOT_RECOGNISED'))
          }
        });
    }
  }


  async sendReset() {
    this.resetSubmitted = true;
    if (this.resetPasswordForm.invalid) {
      return;
    } else {
      let parentDepartment = await this.departmentService.getParentDepartment();

      this.apiService.passwordReset(this.resetPasswordForm.value.resetemail, parentDepartment.id).then((res) => {
        this.resetSuccess = true;
      })

    }
  }

  sendToReset() {
    let staging = ""
    if (window.location.href.includes("staging") || window.location.href.includes("localhost")) {
      staging = "-staging"
    }
    const url = `https://customer.jrni.com/?client=kent&environment=kenthwrc${staging}`
    window.location.href = url
  }

}